import { getClientActionGridColumns } from '@/services/Action/ClientActionGridConfig';

const propertyClientActionFields = [
  'clientActionId',
  'dueDate',
  'dateReferredToLegal',
  'tags',
  'status',
  'lastStatusUpdatedDate',
  'reviewer',
  'currentResponsibleTeam',
  'actionType',
  'priority',
  'description',
];

const columns = getClientActionGridColumns()
  .filter(column => propertyClientActionFields.includes(column.field));
const id = columns.find(column => column.field === 'clientActionId');
id.checkboxSelection = false;
id.headerCheckboxSelection = false;

export const gridColumns = columns;

export const gridDefaultColDef = {
  filter: 'agSetColumnFilter',
  filterParams: {
    selectAllOnMiniFilter: false,
  },
};
